import React from 'react'
import i18n from 'i18next'
import { observer } from 'mobx-react'
import * as R from 'ramda'

import Modal from '../../UniformComponents/Modal'
import Typography from '../../UniformComponents/Typography'
import Button from '../../UniformComponents/Button'
import Select from '../form/Select'

const PresentationTemplateEditModal = ({ templateSearchStore, history }) => {
    const { editTemplateRow, newTemplateEvent } = templateSearchStore
    const surveyType = R.pathOr(null, ['surveyType'], editTemplateRow)
    const respondentType = R.pathOr(null, ['respondentType'], editTemplateRow)

    return (
        <Modal
            show={templateSearchStore.editPresentationModalVisible}
            onClose={templateSearchStore.closeEditPresentationModal}
        >
            <Typography type="h2">{i18n.t('templates.edit.presentation.title')}</Typography>

            <br />

            <Typography type="tiny">{i18n.t('templates.edit.presentation.description')}</Typography>

            <br />

            <hr />

            <br />

            <Select
                name="event"
                label={i18n.t('templates.create.presentation.event')}
                options={templateSearchStore.templateEventOptions(surveyType, respondentType)}
                value={newTemplateEvent}
                onBlur={({ value }) => templateSearchStore.setNewTemplateEvent(value)}
                placeholder={i18n.t('templates.create.presentation.eventPlaceholder')}
            />

            <br />

            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                <Button
                    label={i18n.t('cancel')}
                    onClick={templateSearchStore.closeEditPresentationModal}
                    cssClass="regular tertiary"
                />
                <Button
                    icon="fa-light fa-edit"
                    label={i18n.t('templates.edit.presentation.submit')}
                    onClick={() => templateSearchStore.openTemplateBuilderForEdit(history)}
                    cssClass="regular primary"
                    disabled={!newTemplateEvent}
                />
            </div>
        </Modal>
    )
}

export default observer(PresentationTemplateEditModal)
